export class RecalculateLeveransRedovisningsdatumRelationshipCommand {
    $type = "RecalculateLeveransRedovisningsdatumRelationshipCommand";
    periodFrom: string;
    periodTom: string;
    leveransnummer: string;
    mottagningsplatsId?: number;
}
